import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from 'seagull/components/Typography';
import { validateReviewers } from '~/business-logic/draftLogic';
import AddAdditionalRecipients from '~/components/AgreementStudioPage/AgreementStudioProposalMode/AddAdditionalRecipients/AddAdditionalRecipients';
import { useLocaleKeys } from '~/i18n';
import pluralize from '~/utils/pluralize';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
export default function AdditionalRecipientsCell(param) {
    let { draft, contact, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const numReviewers = draft.reviewers().length;
    const primaryContact = contact || undefined;
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-additional-recipients-".concat(index),
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        onClick: ()=>onOpenModal({
                width: '800px',
                shouldSubmit: (draft)=>Promise.resolve(validateReviewers(draft.reviewers(), primaryContact)),
                renderContent: (param)=>{
                    let { wasSubmitted, draft, setDraft } = param;
                    return {
                        title: t.additionalRecipients(),
                        testId: "edit-additional-recipients-modal",
                        onSubmit: (defaultBehavior)=>{
                            defaultBehavior();
                        },
                        content: /*#__PURE__*/ _jsx(AddAdditionalRecipients, {
                            initialState: draft.reviewers(),
                            showReviewerErrors: wasSubmitted || undefined,
                            primaryContact: primaryContact,
                            onChange: (newReviewers)=>setDraft(draft.setReviewers(newReviewers))
                        })
                    };
                }
            }),
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: "additional-recipients-".concat(index),
            skin: numReviewers ? 'standard' : 'secondary',
            children: numReviewers ? pluralize('additional recipient', numReviewers, true) : 'Not set'
        })
    });
}
